import React from "react";
import Image from "next/image";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import PopUp from "@sellernote/ui/src/sds-v1/components/PopUp";
import NoticeIcon from "@sellernote/ui/src/sds-v2/components/svgIcons/NoticeIcon";
import { COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";

import Styled from "./index.styles";

export default function PopUpAboutForwardingHolidays({
  onClose,
}: {
  onClose: () => void;
}) {
  const { isMobile } = useCheckIsMobile();

  return (
    <PopUp
      popUpKey="pop-up-about-forwarding-holidays-200424-1"
      activePeriod={{
        start: new Date("2025-04-23T15:00:00.000Z"), // 25.04.24
        end: new Date("2025-05-07T15:00:00.000Z"), // 25.05.07 종료까지
      }}
      onClose={onClose}
      content={
        <Styled.container>
          <div className="header">
            <NoticeIcon width={40} height={40} color={COLOR.grayScale_700} />

            <div className="title">중국 노동절 연휴에 따른 운송 지연 안내</div>
          </div>

          <div className="body">
            <div className="schedule">
              <div className="title">중국 노동절 공휴일: 5/1(목) ~ 5/5(월)</div>
              <div className="content">
                {isMobile ? (
                  <Image
                    src={
                      "/assets/images/popUp/PopUpAboutForwardingHolidays/schedule-mobile.png"
                    }
                    alt="logo"
                    width={296}
                    height={94.45}
                    unoptimized
                  />
                ) : (
                  <Image
                    src={
                      "/assets/images/popUp/PopUpAboutForwardingHolidays/schedule-desktop.png"
                    }
                    alt="logo"
                    width={445}
                    height={142}
                    unoptimized
                  />
                )}
              </div>
            </div>
            <div className="note">
              <strong>
                중국 노동절 연휴 전후로 집중된 운송 주문으로 인한 일부 지연
              </strong>
              이 있을 수 있으며,{" "}
              <strong>
                일부 중국 업체들은 해당 공휴일 전후로 장기간 휴무를 시행
              </strong>
              하는 경우도 있어, 현지 물류가 다소 원활히 진행되지 못할 수
              있습니다.
              <br />
              <br />
              또한 <strong>선사들의 항로별 Blank Sailing(임시 결항)</strong>이
              발생할 가능성이 있으며, 최근 중국발 항로에{" "}
              <strong>기상악화로 인한 선박 지연</strong>이 빈번한 상황에
              있습니다.
              <br />
              <br />
              중국발 수입 운송 진행하시는 고객 여러분들께서는 내용 참조하시기
              바라며, 저희 쉽다의 운영 매니저들과 사전 업무 조율이 이뤄지도록
              하겠습니다.
            </div>
            <div className="signature">디지털 포워더 쉽다(ShipDa) 드림</div>
          </div>
        </Styled.container>
      }
    />
  );
}
